
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "support-panel-header",
  components: {},
})
export class SupportPanelHeader extends Vue {}
export default SupportPanelHeader;
